import * as React from 'react';
import Footer from './Footer';
import { Container } from './styled';

interface Props {
  children: React.ReactNode;
}

export const ContainerWithFooter = (props: Props) => (
  <Container>
    { props.children }
    <Footer />
  </Container>
);
